import React from "react";
import "./NoDataComponent.scss";

const NoDataComponent = ({ image, heading, message, text }) => {
  return (
    <div className="no-data-found">
      <div className="">
        <img src={image} alt="noData" />
      </div>
      {heading && (
        <div style={{ marginTop: 15 }}>
          <span
            style={{
              fontWeight: "bold",
              fontSize: 15,
              color: "#1B2027",
              textAlign: "center",
            }}
          >
            {heading}
          </span>
        </div>
      )}
      <div className="d-flex justify-content-center">
        <p
          style={{
            fontSize: 12,
            color: "#707070",
            textAlign: "center",
            marginTop: "10px",
            width: "220px",
            textTransform: "none",
          }}
        >
          {message} {text && <b>{text}</b>}
        </p>
      </div>
    </div>
  );
};

export default NoDataComponent;
